import { VendorBuyOpportunityDocuments } from '../../../components/Vendor';

export function BuyOpportunityDocuments() {
  return <VendorBuyOpportunityDocuments />;
}
